function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { m as _classPrivateMethodInitSpec, _ as _defineProperty, o as _classPrivateMethodGet, j as _classPrivateFieldInitSpec, l as _classPrivateFieldSet, c as ConnectorNotFoundError, k as _classPrivateFieldGet, U as UserRejectedRequestError, R as ResourceUnavailableError } from '../../../dist/base-b565d5d4.esm.js';
import { I as InjectedConnector, g as getClient, s as shimDisconnectKey } from '../../../dist/client-a05fd511.esm.js';
import 'eventemitter3';
import '../../../dist/chains-fd2c546c.esm.js';
import '../../../dist/rpcs-b73a8f60.esm.js';
import 'zustand/vanilla';
import 'zustand/middleware';
import 'ethers';
import 'ethers/lib/utils';

var _provider = /*#__PURE__*/new WeakMap();

var _UNSTABLE_shimOnConnectSelectAccount = /*#__PURE__*/new WeakMap();

var _getReady = /*#__PURE__*/new WeakSet();

var _findProvider = /*#__PURE__*/new WeakSet();

var MetaMaskConnector = /*#__PURE__*/function (_InjectedConnector) {
  _inherits(MetaMaskConnector, _InjectedConnector);

  var _super = _createSuper(MetaMaskConnector);

  function MetaMaskConnector() {
    var _this;

    _classCallCheck(this, MetaMaskConnector);

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        chains = _ref.chains,
        options_ = _ref.options;

    var options = _objectSpread({
      name: 'MetaMask',
      shimDisconnect: true,
      shimChainChangedDisconnect: true
    }, options_);

    _this = _super.call(this, {
      chains: chains,
      options: options
    });

    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _findProvider);

    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _getReady);

    _defineProperty(_assertThisInitialized(_this), "id", 'metaMask');

    _defineProperty(_assertThisInitialized(_this), "ready", typeof window != 'undefined' && !!_classPrivateMethodGet(_assertThisInitialized(_this), _findProvider, _findProvider2).call(_assertThisInitialized(_this), window.ethereum));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _UNSTABLE_shimOnConnectSelectAccount, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _UNSTABLE_shimOnConnectSelectAccount, options.UNSTABLE_shimOnConnectSelectAccount);

    return _this;
  }

  _createClass(MetaMaskConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref2,
            chainId,
            _this$options,
            _getClient$storage,
            _this$options2,
            _getClient$storage2,
            provider,
            accounts,
            isConnected,
            account,
            id,
            unsupported,
            chain,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, chainId = _ref2.chainId;
                _context.prev = 1;
                _context.next = 4;
                return this.getProvider();

              case 4:
                provider = _context.sent;

                if (provider) {
                  _context.next = 7;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 7:
                if (provider.on) {
                  provider.on('accountsChanged', this.onAccountsChanged);
                  provider.on('chainChanged', this.onChainChanged);
                  provider.on('disconnect', this.onDisconnect);
                }

                this.emit('message', {
                  type: 'connecting'
                }); // Attempt to show wallet select prompt with `wallet_requestPermissions` when
                // `shimDisconnect` is active and account is in disconnected state (flag in storage)

                if (!(_classPrivateFieldGet(this, _UNSTABLE_shimOnConnectSelectAccount) && (_this$options = this.options) !== null && _this$options !== void 0 && _this$options.shimDisconnect && !((_getClient$storage = getClient().storage) !== null && _getClient$storage !== void 0 && _getClient$storage.getItem(shimDisconnectKey)))) {
                  _context.next = 17;
                  break;
                }

                _context.next = 12;
                return provider.request({
                  method: 'eth_accounts'
                })["catch"](function () {
                  return [];
                });

              case 12:
                accounts = _context.sent;
                isConnected = !!accounts[0];

                if (!isConnected) {
                  _context.next = 17;
                  break;
                }

                _context.next = 17;
                return provider.request({
                  method: 'wallet_requestPermissions',
                  params: [{
                    eth_accounts: {}
                  }]
                });

              case 17:
                _context.next = 19;
                return this.getAccount();

              case 19:
                account = _context.sent;
                _context.next = 22;
                return this.getChainId();

              case 22:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);

                if (!(chainId && id !== chainId)) {
                  _context.next = 30;
                  break;
                }

                _context.next = 27;
                return this.switchChain(chainId);

              case 27:
                chain = _context.sent;
                id = chain.id;
                unsupported = this.isChainUnsupported(id);

              case 30:
                if ((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.shimDisconnect) (_getClient$storage2 = getClient().storage) === null || _getClient$storage2 === void 0 ? void 0 : _getClient$storage2.setItem(shimDisconnectKey, true);
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: provider
                });

              case 34:
                _context.prev = 34;
                _context.t0 = _context["catch"](1);

                if (!this.isUserRejectedRequestError(_context.t0)) {
                  _context.next = 38;
                  break;
                }

                throw new UserRejectedRequestError(_context.t0);

              case 38:
                if (!(_context.t0.code === -32002)) {
                  _context.next = 40;
                  break;
                }

                throw new ResourceUnavailableError(_context.t0);

              case 40:
                throw _context.t0;

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 34]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (typeof window !== 'undefined') {
                  // TODO: Fallback to `ethereum#initialized` event for async injection
                  // https://github.com/MetaMask/detect-provider#synchronous-and-asynchronous-injection=
                  _classPrivateFieldSet(this, _provider, _classPrivateMethodGet(this, _findProvider, _findProvider2).call(this, window.ethereum));
                }

                return _context2.abrupt("return", _classPrivateFieldGet(this, _provider));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }]);

  return MetaMaskConnector;
}(InjectedConnector);

function _getReady2(ethereum) {
  var isMetaMask = !!(ethereum !== null && ethereum !== void 0 && ethereum.isMetaMask);
  if (!isMetaMask) return; // Brave tries to make itself look like MetaMask
  // Could also try RPC `web3_clientVersion` if following is unreliable

  if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state) return;
  if (ethereum.isTokenPocket) return;
  if (ethereum.isTokenary) return;
  return ethereum;
}

function _findProvider2(ethereum) {
  if (ethereum !== null && ethereum !== void 0 && ethereum.providers) return ethereum.providers.find(_classPrivateMethodGet(this, _getReady, _getReady2));
  return _classPrivateMethodGet(this, _getReady, _getReady2).call(this, ethereum);
}

export { MetaMaskConnector };